import { render, staticRenderFns } from "./CustomCollisionsInfo.vue?vue&type=template&id=4088b47d&"
import script from "./CustomCollisionsInfo.vue?vue&type=script&lang=js&"
export * from "./CustomCollisionsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports